import React from 'react'
import SymptomsContext from '../context/SymptomsContext'
import { get, post } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'

const SymptomsProvider = ({ children }) => {
  const { getIdTokenClaims } = useAuth0()

  const baseUrl = process.env.REACT_APP_API_BASE_URL

  const getSymptoms = async (queryStringParameters) => {
    if (Object.keys(queryStringParameters).length === 0) {
      return {}
    }
    const idToken = await getIdTokenClaims()

    try {
      const queryParams = new URLSearchParams()
      Object.entries(queryStringParameters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          queryParams.append(key, value)
        }
      })

      const pathWithParams = `/health/symptoms?${queryParams.toString()}`

      const resp = get({
        apiName: baseUrl,
        path: pathWithParams,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data.data
    } catch (error) {
      console.log(error)
    }
  }

  const getDetailSymptoms = async (id) => {
    const idToken = await getIdTokenClaims()

    try {
      const resp = get({
        apiName: baseUrl,
        path: `/health/symptoms?id=${id}`,
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data.data
    } catch (error) {
      console.log(error)
    }
  }

  const postSymptoms = async (id, answer) => {
    const idToken = await getIdTokenClaims()
    try {
      const resp = post({
        apiName: baseUrl,
        path: '/health/symptoms',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          },
          body: {
            id,
            response: answer
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <SymptomsContext.Provider
      value={{ getSymptoms, getDetailSymptoms, postSymptoms }}
    >
      {children}
    </SymptomsContext.Provider>
  )
}

export default SymptomsProvider
